<template>
  <div class="text-gray-600 w-full md:w-auto">
    <div
      class="cursor-pointer inline-block w-max"
      :class="{ 'text-pink-600': mutableValue }"
    >
      <icon :id="name" name="message-circle" class="comment-input" />
    </div>
    <div class="relative"
         v-clickOutside="forceHide"

    >
      <textarea
        class="comment-text absolute z-20 top-0 right-0 w-full md:w-auto py-4 px-5 rounded-lg bg-white shadow-md shadow-gray-600 text-base focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50"
        :class="{ 'cursor-not-allowed': disabled || disabled_pass }"
        :name="name"
        rows="9"
        cols="40"
        v-model="mutableValue"
        v-show="show"
        :placeholder="
          disabled || disabled_pass ? '' : 'Ecrivez votre commentaire'
        "
        :disabled="disabled || disabled_pass"
      />
      <div
        class="absolute z-20 mb-4 right-0 inset-y-0 pt-6 pr-6 flex items-center cursor-pointer"
      >
        <SpeechToText
          v-show="show"
          @result="(result) => updateMutable(result)"
          @startRecognition="startRecognition"
          @stopRecognition="stopRecognition"
        ></SpeechToText>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon';
import SpeechToText from './SpeechToText.vue';

export default {
  components: {
    SpeechToText,
    Icon,
  },
  props: ['name', 'value', 'necessary', 'disabled'],
  data: function () {
    return {
      mutableValue: this.value,
      valueBeforeSpeech: undefined,
      disabled_pass: false,
      show: false,
    };
  },
  mounted() {
    // Manage edit permission for neopass pages
    if (this.$route.path.includes('form/neopass')) {
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if (this.$can(page + '_edit', idpass)) {
        this.disabled_pass = false;
      } else {
        this.disabled_pass = true;
      }
    } else {
      this.disabled_pass = false;
    }
  },
  methods: {
    startRecognition () {
      this.valueBeforeSpeech = this.mutableValue;
    },

    stopRecognition() {
      this.valueBeforeSpeech = undefined;
    },

    updateMutable(value) {
      this.mutableValue = `${this.valueBeforeSpeech ?? ''} ${value}`;
    },

    displayComment(e) {
      if (e.x < (2 * window.outerWidth) / 3) {
        //to move the bloc options on right or left according to the position on the screen
        document
          .querySelectorAll(".comment-text[name='" + this.name + "']")[0]
          .classList.remove('right-0');
      }
      this.show = !this.show;
    },

    forceHide(e) {
      if (
        e.target.classList.contains('comment-input') &&
        e.target.id == this.name &&
        !this.disabled_pass
      ) {
        this.displayComment(e);
      } else {
        if (this.show) {
          this.show = false;
        }
      }
    },
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);
    },
    value() {
      this.mutableValue = this.value;
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
</script>